module.exports = __webpack_public_path__ + "img/7.89d01202.png";